import { Link } from 'react-router-dom';

// 首页只展示品牌首屏内容；Fashion、Art、Writing、About、Contact 由独立路由承载。
export default function HomePage() {
  return (
    <main>
      <section className="hero hero-home">
        <div className="hero-text hero-text-home">
          <p className="hero-eyebrow">New York - Fashion / Art / Conceptual practice</p>
          <p className="manifesto-line">Evacuate from Meaning</p>
          <p className="manifesto-line">is not built on symbols,</p>
          <p className="manifesto-line">narratives, or predefined values.</p>
          <p className="manifesto-line indent">It begins with a refusal -</p>
          <p className="manifesto-line indent">a refusal to explain,</p>
          <p className="manifesto-line indent">to signify,</p>
          <p className="manifesto-line indent">to be read correctly.</p>
          <div className="hero-note-block">
            <p className="hero-note">
              A portfolio and living archive of garments, performances, images, and objects that
              resist fixed interpretation.
            </p>
            <div className="hero-actions">
              <Link to="/fashion" className="hero-action">
                Enter Fashion
              </Link>
              <Link to="/art" className="hero-action hero-action--muted">
                Enter Art
              </Link>
              <Link to="/writing" className="hero-action hero-action--muted">
                Enter Writing
              </Link>
            </div>
          </div>
        </div>
        <div className="hero-image hero-image-home">
          <img
            loading="eager"
            decoding="async"
            src="/assets/hero-campaign.jpg"
            fetchPriority="high"
            alt="Campaign"
            className="hero-img"
          />
        </div>
      </section>
    </main>
  );
}

export function AboutCopy() {
  return (
    <div className="about-content">
      <p>
        Evacuate from Meaning is a fashion brand founded in New York City in 2026 by Jiangyuan Ai, a
        Parsons School of Design fashion graduate.
      </p>
      <p>
        Rooted in fashion while extending into art and conceptual practice, the brand approaches
        clothing not as representation, but as a condition of existence.
      </p>
      <p className="quote">
        &quot;In a world obsessed with interpretation, we choose evacuation.&quot;
      </p>
      <p>Here, garments are not answers. They are conditions.</p>
      <p className="final">No definitions. No conclusions. Only continuous departure.</p>
    </div>
  );
}

// ContactCopy 被首页和独立 Contact 页面复用，确保联系信息只维护一份。
export function ContactCopy() {
  return (
    <div className="contact-content">
      <p>
        <a href="https://instagram.com/evacuate.from.meaning" target="_blank" rel="noreferrer">
          Instagram
        </a>
      </p>
      <p>
        <a href="mailto:Info@efmnyc.com">Info@efmnyc.com</a>
      </p>
    </div>
  );
}
